import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#F2674A",
    },
    secondary: {
      main: "#dc004e",
    },
    error: {
      main: "#ff6969",
    },
    warning: {
      main: "#ffa726",
    },
    info: {
      main: "#2196f3",
    },
    success: {
      main: "#4caf50",
    },
    background: {
      default: "#F2674A", // <-- fixed double ##
    },
  },

  components: {
    MuiChip: {
      styleOverrides: {
        root: {
          color: "#ffffff !important",
          fontWeight: 500,
        },
        filledDefault: {
          backgroundColor: "#616161",
          color: "#ffffff",
        },
        outlined: {
          borderColor: "#ffffff50",
          color: "#ffffff",
        },
      },
    },

    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#434343", // Border color
            },
            "&:hover fieldset": {
              borderColor: "#918e8e", // Border color on hover
            },
            "&.Mui-focused fieldset": {
              borderColor: "#F2674A", // Border color when focused
            },
          },
        },
      },
    },

    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#434343", // Border color
            },
            "&:hover fieldset": {
              borderColor: "#918e8e", // Border color on hover
            },
            "&.Mui-focused fieldset": {
              borderColor: "#F2674A", // Border color when focused
            },
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          root: {
            "& .MuiOutlinedInput-root": {
              color: "#ffffff", // Text color for the input
            },
          },
        },
      },
    },
  },
});

export default theme;
